import { getStripe } from "lib/stripe/client"
import { postData } from "lib/stripe/helpers"
import { useUser } from "lib/supabase/auth"
import { useRouter } from "next/router"
import { useMutation } from "react-query"

export const useCheckout = () => {
  const { push } = useRouter()
  const { session } = useUser()

  return useMutation<void, Error, string>(async (price) => {
    if (!session) {
      push("/auth/registration")
    } else {
      const { sessionId } = await postData({
        url: "/api/stripe/create-checkout-session",
        data: { price },
        token: session?.access_token,
      })

      const stripe = await getStripe()
      stripe?.redirectToCheckout({ sessionId })
    }
  })
}
